export default {
  WINDOWS_APP: "AeonTimeline3:Windows",
  MAC_APP: "AeonTimeline3:Mac",
  IOS_APP: "AeonTimeline3:iOS",
  IOS_MOBILE_APP: "AeonTimeline3:iPhone",
  IOS_12_MOBILE_APP: "AeonTimeline3:iPhoneiOS12",
  IOS_TABLET_APP: "AeonTimeline3:iPad",
  IOS_12_TABLET_APP: "AeonTimeline3:iPadiOS12",
  MAC_SCREENSHOT: "AeonTimeline3:Mac:Screenshot",
  TABLET_SCREENSHOT: "AeonTimeline3:iPad:Screenshot",
  MOBILE_SCREENSHOT: "AeonTimeline3:iPhone:Screenshot"
};
